var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.channelLink,"target":"_blank"}},[_c('img',{staticClass:"sched-app-logo",attrs:{"src":("img/" + _vm.channel + ".png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }